import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Auth0Provider from './Infrastructure/Auth/Auth0Provider';

window.$ = $;
window.jQuery = $;

require('bootstrap/dist/js/bootstrap');
const App = require('./App').default;

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider>
      <App />
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
